export class PageUserRequest {
  page: number;
  size: number;

  ascDirection: number;
  criteria: string;

  searchId: any;
  searchFullName: any;
  searchRole: any;
  searchPremium: any;
  searchEmail: any;
  searchCreatedAt: any;

  constructor(page: number, size: number, ascDirection: number) {
    this.page = page;
    this.size = size;
    this.ascDirection = ascDirection;
  }
}
